import styled from 'styled-components';

export const CompanyDataContainer = styled.div.attrs({})`
  display: flex;
  gap: 20px;
  width: 100%;
`;

export const CloseContainer = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
  padding-bottom: 12px;
`;

export const ContainerColumn = styled.div.attrs({})`
  flex: 1;
  &:first-child {
    border-right: 1px solid ${(props) => props.theme.palette.colors.shadow};
    padding-right: 20px;
  }
`;
